import { useEffect } from "react";
import { Box, Button, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import ModalForm from "@/shared/components/ui/ModalForm";
import { CustomTextField } from "@/shared/components/ui";
import { useFetchReprogramarCambio } from "@/shared/actions";
import { Cambio } from "../../types";

type Props = { open: boolean; onClose: () => void; cambio: Cambio | null };
type FormValues = { fechaProgramada: string; horaProgramada: string; duracion: number };

export default function ModalReprogramarCambio({ open, onClose, cambio }: Props) {
  const reprogramar = useFetchReprogramarCambio();
  const form = useForm<FormValues>({ defaultValues: { fechaProgramada: "", horaProgramada: "", duracion: 1 } });
  const { control, handleSubmit, reset, formState: { errors } } = form;

  useEffect(() => {
    if (open && cambio) {
      reset({
        fechaProgramada: cambio.fechaProgramada ?? "",
        horaProgramada: (cambio.horaProgramada ?? "").slice(0, 5), // "HH:mm"
        duracion: Number(cambio.duracion) || 1,
      });
    }
  }, [open, cambio, reset]);

  const onSubmit = (v: FormValues) => {
    if (!cambio?.id) return;
    reprogramar.mutate(
      { id: cambio.id, data: { ...v, duracion: Number(v.duracion) } },
      { onSuccess: onClose }
    );
  };

  return (
    <ModalForm open={open} onClose={onClose} title="Cambiar fechas del cambio" maxWidth={480}>
      <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: 1 }}>
        <Stack spacing={2}>
          <CustomTextField label="Fecha programada" name="fechaProgramada" type="date"
            control={control} defaultValue="" error={errors.fechaProgramada}
            helperText={errors.fechaProgramada?.message ?? ""} />
          <CustomTextField label="Hora programada" name="horaProgramada" type="time"
            control={control} defaultValue="" error={errors.horaProgramada}
            helperText={errors.horaProgramada?.message ?? ""} />
          <CustomTextField label="Duración (horas)" name="duracion" type="number"
            control={control} defaultValue="" error={errors.duracion}
            helperText={errors.duracion?.message ?? ""} />
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button variant="outlined" onClick={onClose} disabled={reprogramar.isPending}>Cancelar</Button>
            <Button type="submit" variant="contained" disabled={reprogramar.isPending}>Guardar</Button>
          </Box>
        </Stack>
      </Box>
    </ModalForm>
  );
}